export const LIGHT_ME_UP = 9999;
export const getKey = ({ groupName, stepName }) => `${groupName ?? ''}.${stepName ?? ''}`;

export const getElement = (maybeElementId: string, map) =>
  document.getElementById(maybeElementId) ?? document.getElementById(map[maybeElementId]?.domId);

export const getRectMap = (stepMap = {} as any) => {
  return Object.entries(stepMap).reduce((acc, [key, value]) => {
    const domElement = document.getElementById((value as any)?.domId);
    const rect = domElement?.getBoundingClientRect();

    return { ...acc, [key]: rect };
  }, {});
};

export const getPositioning = ({ step, groupName, rectMap }) => {
  const key = getKey({ groupName, stepName: step.name });
  const rect = rectMap?.[key] ?? rectMap?.[groupName] ?? rectMap?.[step.name];

  if (rect) {
    return {
      top: rect?.top + step.position.offset.top,
      left: rect?.left + step.position.offset.left
    };
  }

  if (step.position?.offset)
    return {
      ...step.position?.offset
    };

  return undefined;
};
